import {
  brandClassName, getBrandInfo, isINCHBrand, isAnsweringServiceBrand, isLexReceptionUKBrand,
  isSetmoreStartNowPage,
} from '../helpers/brands';
import {
  getBrandSpecificHeader,
  SuspenseWrapper,
} from '../helpers/dynamic-import-helper';
import '../helpers/sentry/sentry-config';

const brandInfo = getBrandInfo();

const BrandHeader = getBrandSpecificHeader();

export default function header() {
  return (
    <header className={`header fx-hd ${isINCHBrand || isLexReceptionUKBrand || isSetmoreStartNowPage() ? 'container' : ''}`}>
      <a
        data-testid="headerLink"
        href={brandInfo.websiteUrl}
        rel="noopener noreferrer"
        target={isAnsweringServiceBrand ? '' : '_blank'}
        className={`logo-brand ${brandClassName}`}
        tabIndex="-1"
      >
        <img src={brandInfo.logo} />
      </a>
      <SuspenseWrapper>
        <BrandHeader />
      </SuspenseWrapper>
    </header>
  );
}
